import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NotificationLogModel } from 'lemunzo-api';
import { SharedDialogShellConfig } from '../../models/shared-dialog-shell-config';
import { TranslateDatePipe } from '../../pipes/translate-date.pipe';
import { SharedDialogShellComponent } from '../shared-dialog-shell/shared-dialog-shell.component';

@Component({
    selector: 'apcam-notification-log-detail-confirmation',
    templateUrl: './notification-log-detail-dialog.component.html',
    styleUrls: ['./notification-log-detail-dialog.component.scss'],
    imports: [
        MatButtonModule,
        MatIconModule,
        SharedDialogShellComponent,
        TranslateDatePipe,
        TranslatePipe,
    ],
})
export class NotificationLogDetailDialogComponent {
    protected get dialogShellConfig(): SharedDialogShellConfig<void> {
        return {
            title:
                this.notificationLog.title ??
                this.translateService.instant(
                    'shared.skeleton.notifications.detailDialog.title'
                ),
            cancelLabel: this.translateService.instant('shared.buttons.close'),
            cancelIcon: 'close',
            showConfirmButton: false,
            onCancel: () => this.dialogRef.close(),
        };
    }

    constructor(
        @Inject(MAT_DIALOG_DATA)
        protected readonly notificationLog: NotificationLogModel,
        private readonly dialogRef: MatDialogRef<NotificationLogDetailDialogComponent>,
        private readonly translateService: TranslateService
    ) {}
}
